import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {getGuilds} from '../store/GuildsStore';
import {getMe} from '../store/CurrentUser';

export const useInitServers = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGuilds());
    dispatch(getMe());
  }, [dispatch]);
};
